import React from 'react';
import SelkirkIcon from './SelkirkIcon';

/** Icon-only control (close, dismiss). */
const IconButton = ({
  icon = 'ui-close',
  onClick,
  className = 'dd-icon-button',
  ariaLabel,
  type = 'button',
  size = 20,
  disabled,
}) => (
  <button
    type={type}
    className={className}
    onClick={onClick}
    aria-label={ariaLabel}
    disabled={disabled}
  >
    <SelkirkIcon name={icon} size={size} decorative />
  </button>
);

export default IconButton;
